import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import classname from 'classname';
import moment from 'moment';
import Animate from '../../../shared/animation';
import { Link } from 'react-router';
import { notFound, showMoreRows } from '../../../shared/table-helpers';
import ImagePlaceholdered from '../../../shared/image-placeholdered';

import map from 'lodash/map';

lessRequire('modules/news/components/table/list.less');

const NewsList = ({
	rows,
	openedNewsId,
	openedNewsOffers,
	toggleNews,
	newsTypesEnum,
	isCanNotMoveToNext,
	showMore,
	intl
}) => (
	<Animate>
		<table className="news-table">
			<tbody className="news-table__body">
				{ rows.length
					? buildRows(rows, openedNewsId, openedNewsOffers, toggleNews, newsTypesEnum, intl)
					: notFound(intl)
				}
				{ !isCanNotMoveToNext && rows.length && showMore ? showMoreRows(showMore, 'NewsList', intl) : null }
			</tbody>
		</table>
	</Animate>
);

const buildRows = (
	tableRows,
	openedNewsId,
	openedNewsOffers,
	toggleNews,
	newsTypesEnum,
	intl
) => {
	const result = [];

	tableRows.forEach((row, i) => {
		result.push(
			<tr className="news-table__grouped" key={i}>
				<td colSpan="3">
					<span className="news-table__grouped-date font-proxima-nova-semibold">
						{
							moment(row.date).isSame(new Date(), 'day') ?
								intl('Сегодня') :
								moment(row.date).locale(intl.language).format('D MMMM')
						}
					</span>
				</td>
			</tr>
		);

		(row.news).forEach((news, newsIndex) => {
			const newsId = `${i}_${newsIndex}_news`;
			const shouldOpenNews = openedNewsId === newsId;
			const shouldOpenAndHasOffers = shouldOpenNews && openedNewsOffers && openedNewsOffers.length > 0;
			result.push(
				<tr className={classname({
					'news-table__list': true,
					'no-border': (row.news.length-1) === newsIndex || shouldOpenAndHasOffers
				})} key={newsId}>
					<td className="time">
						<span>{ moment(news.published_at).format('HH:mm') }</span>
					</td>
					<td className="type">
						<span className={getNewsClassByType(news.type, newsTypesEnum)}/>
						{shouldOpenAndHasOffers && (<div className="arrow-vertical-line" />)}
					</td>
					<td className={classname({'news': true, 'is-open': shouldOpenNews})}>
						<div className={classname({ 'news__title': true, 'font-proxima-nova-semibold': shouldOpenNews  })}>
							<a href="#" onClick={e => {e.preventDefault(); toggleNews(newsId, news.id);}}>{news.title}</a>
							<span className="news__title-close" onClick={e => {e.preventDefault(); toggleNews(newsId, news.id);}} />
						</div>

						{shouldOpenNews && (
							<Animate>
								<p
									className={classname({
										'news__text': news.type !== 'new_offer',
										'news__text--email': news.type === 'new_offer'
									})}
									dangerouslySetInnerHTML={{__html: news.text}} />
							</Animate>
						)}

					</td>
				</tr>
			);

			if (shouldOpenNews) {
				result.push(
					<tr className={classname({
						'news-offers': true,
						'no-border': (row.news.length-1) === newsIndex
					})} key={`adv-row-${newsId}`}>
						<td></td>
						<td>
							{shouldOpenAndHasOffers && (
								<div className="offers-arrow">
									<div className="arrow-bottom" />
								</div>
							)}
						</td>
						<td>
							<div className="offers">
								{map(openedNewsOffers, o => {
									return (
										<Link key={`offers${o.id}`} to={`offers/${o.id}`} target="__blank" className="offer">
											<ImagePlaceholdered
												src={o.image}
												className="offer-img"
											/>
											<span className="offer-title">{o.title}</span>
										</Link>
									);
								})}
							</div>
						</td>
					</tr>
				);
			}
		});
	});

	return result;
};

export const getNewsClassByType = (type, newsTypesEnum) => classname({
	'news-type': true,
	'icon-custom': type === newsTypesEnum.custom,
	'icon-new-offer': type === newsTypesEnum.new_offer,
	'icon-offer-change': type === newsTypesEnum.offer_change,
	'icon-offer-stop': type === newsTypesEnum.offer_stop,
	'icon-geo-added': type === newsTypesEnum.geo_added,
	'icon-geo-removed': type === newsTypesEnum.geo_removed,
	'icon-new-landing': type === newsTypesEnum.new_landing,
	'icon-promo': type === newsTypesEnum.promo
});

NewsList.propTypes = {
	rows: PropTypes.array,
	openedNewsId: PropTypes.string,
	openedNewsOffers: PropTypes.array,
	toggleNews: PropTypes.func,
	newsTypesEnum: PropTypes.object,
	isCanNotMoveToNext: PropTypes.bool,
	showMore: PropTypes.func,
	intl: PropTypes.func
};

export default NewsList;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/news/components/table/list.js